export default __webpack_public_path__ + "static/media/frontdesk-booking-view.cf43502f.jpg";